import * as React from "react";

import {
  usePlpPresenterForTheSortingMenu,
  useProductListState,
  useProductListPresentationModel,
} from "../providers";

export const Content: React.FunctionComponent = () => {
  const { selectedSortingOption } = useProductListState();
  const { PlpSortingOptions } = useProductListPresentationModel();

  const { handleActionSortingOption } = usePlpPresenterForTheSortingMenu();

  const options = React.useMemo(() => {
    return PlpSortingOptions.map((option, index) => {
      const key = `sorting-option-${index}`;
      const isSelected = option.value === selectedSortingOption.value;

      const action: React.MouseEventHandler = () => {
        handleActionSortingOption(option);

        window.dataLayer.push({
          event: 'sort_by',
          value: option.label
        });
      };

      // labels propagate clicks to inputs they're associated with,
      // which then propagates to the parent element,
      // which also catches the initial propagation from the label click,
      // causing it to be called twice.
      // so we stop the default behaviour of label's click,
      // to prevent it passing the event along to its associated input.
      const onLabelClick: React.MouseEventHandler = (
        event: React.MouseEvent
      ) => {
        event.preventDefault();
      };

      return (
        <div
          key={key}
          className={`option ${isSelected ? "selected" : ""}`}
          onClick={action}
        >
          <input type="radio" id={key} name={key} checked={isSelected} />
          <label htmlFor={key} className="name" onClick={onLabelClick}>
            {option.label}
          </label>
        </div>
      );
    });
  }, [PlpSortingOptions, selectedSortingOption, handleActionSortingOption]);

  return <div className="content options">{options}</div>;
};
